<template>
	<div class="flow-history-card-wrapper">
		<h5 v-if="when" class="fc-light upper-case flow-history-card-when">
			{{ when }}
		</h5>
		<div class="display-flex flex-d-c flex-vertical-gap-16 flow-history-card" :selected="selected">
			<div class="display-flex flex-d-c">
				<div class="fc-dark display-flex align-items-center">
					<span>{{ date }}</span>
					<Tag v-if="tagType" class="margin-lt-auto" :type="tagType">
						{{ tagText }}
					</Tag>
				</div>
				<div class="fc-light paragraph-1">
					{{ duration }}
				</div>
				<div class="fc-light paragraph-1">
					<slot name="status" />
				</div>
				<div class="fc-light paragraph-1">
					{{ by }}
				</div>
			</div>
		</div>
		<Divider />
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Divider from "./../Divider/Divider";
import Tag from "./../Tag/Tag";

export default defineComponent({
	name: "HistoryCard",
	components: {
		Divider,
		Tag
	},
	props: {
		when: {
			type: String,
			default: null
		},
		date: {
			type: String,
			default: null
		},
		duration: {
			type: String,
			default: null
		},
		by: {
			type: String,
			default: null
		},
		tagType: {
			type: String,
			default: null
		},
		tagText: {
			type: String,
			default: null
		},
		selected: {
			type: Boolean,
			default: false
		}
	}
});
</script>
<style lang="scss">
div.flow-history-card-wrapper {
	> .flow-history-card-when {
		padding: 12px 24px 12px 24px;
		cursor: default;
	}
	> div.flow-history-card {
		padding: 12px 24px 12px 24px;
		cursor: pointer;
		&:hover {
			background-color: var(--dashboard-element-light);
		}
		&[selected] {
			background-color: var(--dashboard-element-light);
		}
	}
}
</style>
